import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    // If targets are specified, use them. Otherwise validate all name inputs in the form
    if (this.hasInputTarget) {
      this.inputTargets.forEach(input => this.setupValidation(input))
    } else {
      // Auto-detect first_name and last_name fields
      const nameInputs = this.element.querySelectorAll('input[name*="first_name"], input[name*="last_name"]')
      nameInputs.forEach(input => this.setupValidation(input))
    }
  }

  setupValidation(input) {
    // Set HTML5 validation attributes
    input.setAttribute('pattern', "[a-zA-Z\\s\\-']+")
    input.setAttribute('maxlength', '50')
    input.setAttribute('title', "Name can only contain letters, spaces, hyphens, and apostrophes")
  }

  validate(event) {
    const input = event.target
    const value = input.value
    const feedback = input.closest('.form-group')?.querySelector('.invalid-feedback')

    // Allow only letters, spaces, hyphens, apostrophes
    const namePattern = /^[a-zA-Z\s\-']*$/

    if (!namePattern.test(value)) {
      // Remove invalid characters as user types
      const cleaned = value.replace(/[^a-zA-Z\s\-']/g, '')
      input.value = cleaned
      
      if (feedback) {
        feedback.textContent = "Name can only contain letters, spaces, hyphens, and apostrophes"
        feedback.style.display = 'block'
        input.classList.add('is-invalid')
      }

      // Clear error after 3 seconds
      setTimeout(() => {
        if (feedback) {
          feedback.style.display = 'none'
          input.classList.remove('is-invalid')
        }
      }, 3000)
    } else {
      if (feedback) {
        feedback.style.display = 'none'
        input.classList.remove('is-invalid')
      }
    }
  }
}